import { initI18n } from '@moneytome/shared';

import kk from './locales/kk.json';
import ru from './locales/ru.json';
import { readLanguagePreference, saveLanguagePreference } from './lib/language-preference';

export const i18n = initI18n(
  {
    ru: { translation: ru },
    kk: { translation: kk },
  },
  readLanguagePreference(),
);

i18n.on('languageChanged', saveLanguagePreference);
